const detachableTrailers = [
  {
    model: "TH540 PLATEAU + DECK",
    cargo_dimensions: "540 X 244 X 70 CM",
    total_length: "690 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "570 KG",
    loading_capacity: "2930 KG",
    price: 4100,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH540.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH600 PLATEAU + DECK",
    cargo_dimensions: "600 X 244 X 70 CM",
    total_length: "750 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "600 KG",
    loading_capacity: "2900 KG",
    price: 4200,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH600.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH660 PLATEAU + DECK",
    cargo_dimensions: "660 X 244 X 70 CM",
    total_length: "810 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "620 KG",
    loading_capacity: "2880 KG",
    price: 4300,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH660.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH720 PLATEAU + DECK",
    cargo_dimensions: "720 X 244 X 70 CM",
    total_length: "870 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "650 KG",
    loading_capacity: "2850 KG",
    price: 4400,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH720.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH720 PLATEAU + DECK",
    cargo_dimensions: "720 X 244 X 70 CM",
    total_length: "870 CM",
    axles: "3 x AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "690 KG",
    loading_capacity: "2810 KG",
    price: 4650,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH720 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH720 PLATEAU + DECK",
    cargo_dimensions: "720 X 244 X 70 CM",
    total_length: "870 CM",
    axles: "3 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "780 KG",
    loading_capacity: "2720 KG",
    price: 4950,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH720 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH780 PLATEAU + DECK",
    cargo_dimensions: "780 X 244 X 70 CM",
    total_length: "930 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "680 KG",
    loading_capacity: "2820 KG",
    price: 4350,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH780.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH780 PLATEAU + DECK",
    cargo_dimensions: "780 X 244 X 70 CM",
    total_length: "930 CM",
    axles: "3 x AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "720 KG",
    loading_capacity: "2780 KG",
    price: 4750,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH780 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH780 PLATEAU + DECK",
    cargo_dimensions: "780 X 244 X 70 CM",
    total_length: "930 CM",
    axles: "3 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "800 KG",
    loading_capacity: "2700 KG",
    price: 5050,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH780 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH840 PLATEAU + DECK",
    cargo_dimensions: "840 X 244 X 70 CM",
    total_length: "990 CM",
    axles: "2 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "700 KG",
    loading_capacity: "2800 KG",
    price: 4550,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH840.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH840 PLATEAU + DECK",
    cargo_dimensions: "840 X 244 X 70 CM",
    total_length: "990 CM",
    axles: "3 x AS 1350 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "740 KG",
    loading_capacity: "2760 KG",
    price: 4950,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH840 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "TH840 PLATEAU + DECK",
    cargo_dimensions: "840 X 244 X 70 CM",
    total_length: "990 CM",
    axles: "3 x AS 1800 KG",
    maximum_authorized_mass: "3500 KG",
    own_mass: "820 KG",
    loading_capacity: "2680 KG",
    price: 5250,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/TH840 3axles.jpg",
    imgAlt: "detachable trailer",
  },
  {
    model: "DT540 DECK",
    cargo_dimensions: "540 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "185 KG",
    price: 1850,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  },
  {
    model: "DT600 DECK",
    cargo_dimensions: "600 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "203 KG",
    price: 1900,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  },
  {
    model: "DT660 DECK",
    cargo_dimensions: "660 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "224 KG",
    price: 1950,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  },
  {
    model: "DT720 DECK",
    cargo_dimensions: "720 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "270 KG",
    price: 2000,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  },
  {
    model: "DT780 DECK",
    cargo_dimensions: "780 X 244 X 18 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "287 KG",
    price: 2050,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  },
  {
    model: "DT840 DECK",
    cargo_dimensions: "840 X 244 X 18 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "309 KG",
    price: 2100,
    newPrice: null,
    img: "images/detachable-trailers-2025-copy/Detachable Deck.jpg",
    imgAlt: "detachable trailer",
    onlyDeck: true
  }
];


export default detachableTrailers;
